import workOrderPriorityUtilities from '@atom/utilities/workOrderPriorityUtilities';

interface Props {
  priorityId: number;
}

const WorkPriorityIcon = ({ priorityId }: Props) => {
  return (
    <>{workOrderPriorityUtilities.getWorkPriorityStatusIcon(priorityId)}</>
  );
};

export default WorkPriorityIcon;
